enum MessageThreadActions {
    ADD_TO_MESSAGE = 'add user to message thread',
    REMOVE_THREAD_MEMBER = 'remove user from message thread',
}

export default MessageThreadActions;
